import { render } from "./AddBescStep3.vue?vue&type=template&id=4a83da13&scoped=true&ts=true"
import script from "./AddBescStep3.vue?vue&type=script&lang=ts"
export * from "./AddBescStep3.vue?vue&type=script&lang=ts"

import "./AddBescStep3.vue?vue&type=style&index=0&id=4a83da13&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a83da13"]])

export default __exports__